import { lazyWithRetry } from 'utils/lazyWithRetry';
export const DashboardPage = lazyWithRetry(()=>import('routes/dashboard').then(({ DashboardReportPage })=>({
            default: DashboardReportPage
        })));
export const ProjectRoutes = lazyWithRetry(()=>import('routes/projects').then(({ ProjectRoute })=>({
            default: ProjectRoute
        })));
export const Home = lazyWithRetry(()=>import('routes/home').then(({ HomePage })=>({
            default: HomePage
        })));
// [will be used later]
// export const Home = lazyWithRetry(() =>
//   import('v2/features/home/public').then(({ HomeFeature }) => ({
//     default: HomeFeature,
//   })),
// );
export const ResourceManagementPage = lazyWithRetry(()=>import('routes/resource-management').then(({ ResourceManagementRoute })=>({
            default: ResourceManagementRoute
        })));
export const AllTasksPage = lazyWithRetry(()=>import('components/pages/all-tasks/all-tasks-v2-page').then(({ AllTasksV2Page })=>({
            default: AllTasksV2Page
        })));
export const NotificationsPage = lazyWithRetry(()=>import('routes/notifications').then(({ Notifications })=>({
            default: Notifications
        })));
export const ReportsRoutes = lazyWithRetry(()=>import('routes/reports/reports').then(({ ReportsRoute })=>({
            default: ReportsRoute
        })));
export const TimesheetsRoutes = lazyWithRetry(()=>import('routes/timesheets').then(({ TimesheetsRoute })=>({
            default: TimesheetsRoute
        })));
export const ExpensesRoutes = lazyWithRetry(()=>import('routes/expenses').then(({ ExpenseRoutes })=>({
            default: ExpenseRoutes
        })));
export const RevenueEntryRoutes = lazyWithRetry(()=>import('routes/revenue-entries').then(({ RevenueEntriesRoutes })=>({
            default: RevenueEntriesRoutes
        })));
export const TemplatesRoutes = lazyWithRetry(()=>import('routes/templates').then(({ TemplatesRoute })=>({
            default: TemplatesRoute
        })));
export const LazyRespSpaceTabPage = lazyWithRetry(()=>import('routes/responsive/resp-space-tab').then(({ RespSpaceTabPage })=>({
            default: RespSpaceTabPage
        })));
export const AutomationLogsByAutomationIdPage = lazyWithRetry(()=>import('routes/automations/automations-logs-by-automation-id').then(({ AutomationLogsByAutomationId })=>({
            default: AutomationLogsByAutomationId
        })));
export const LazyRespStatusUpdate = lazyWithRetry(()=>import('routes/responsive/resp-status-update-content').then(({ RespStatusUpdate })=>({
            default: RespStatusUpdate
        })));
export const LazyRespTaskDesc = lazyWithRetry(()=>import('routes/responsive/resp-task-desc').then(({ RespTaskDesc })=>({
            default: RespTaskDesc
        })));
export const LazyTaskDetailsPageResponsive = lazyWithRetry(()=>import('routes/tasks/task-details-responsive').then(({ TaskDetailsPageResponsive })=>({
            default: TaskDetailsPageResponsive
        })));
export const LazyFeatureFlagList = lazyWithRetry(()=>import('routes/feature-flags').then(({ FeatureFlagList })=>({
            default: FeatureFlagList
        })));
export const TimesheetFeatureDiscoveryPage = lazyWithRetry(()=>import('components/pages/timesheet/feature-discovery').then(({ TimesheetFeatureDiscovery })=>({
            default: TimesheetFeatureDiscovery
        })));
export const NotFoundPage = lazyWithRetry(()=>import('routes/404').then(({ NotFound })=>({
            default: NotFound
        })));
export const LazyIntroModal = lazyWithRetry(()=>import('routes/vendor/intro-modal').then(({ IntroModal })=>({
            default: IntroModal
        })));
// export const LazyG2Popup = lazyWithRetry(() =>
//   import('components/organisms/g2/popup').then(({ G2Popup }) => ({
//     default: G2Popup,
//   })),
// );
export const AllTasksBoard = lazyWithRetry(()=>import('components/pages/all-tasks/board').then(({ AllTasksBoardPage })=>({
            default: AllTasksBoardPage
        })));
export const FormPreviewPage = lazyWithRetry(()=>import('routes/form-preview').then(({ FormPreview })=>({
            default: FormPreview
        })));
export const AttachmentWorkspacePage = lazyWithRetry(()=>import('components/pages/workspace').then(({ AttachmentWorkspace })=>({
            default: AttachmentWorkspace
        })));
export const OverlayComparisonPage = lazyWithRetry(()=>import('components/pages/workspace').then(({ OverlayComparison })=>({
            default: OverlayComparison
        })));
export const SideBySideComparePage = lazyWithRetry(()=>import('components/pages/workspace').then(({ SideBySideComapre })=>({
            default: SideBySideComapre
        })));
export const CustomerPortfolioPage = lazyWithRetry(()=>import('routes/customer-portfolio').then(({ CustomerPortfolioRoute })=>({
            default: CustomerPortfolioRoute
        })));
export const SprintPlanningRoute = lazyWithRetry(()=>import('routes/sprint-planning/sprint-planning-route-component').then((module)=>({
            default: module.SprintPlanningRouteComponent
        })));
export const CustomerPortalListPage = lazyWithRetry(()=>import('routes/customer-portal/customer-portal-list').then(({ CustomerPortalListPage: Page })=>({
            default: Page
        })));
export const NewCustomerPortalPage = lazyWithRetry(()=>import('routes/customer-portal/new-customer-portal-page').then(({ NewCustomerPortalPage: Page })=>({
            default: Page
        })));
export const CustomerPortalById = lazyWithRetry(()=>import('routes/customer-portal/customer-portal-by-id').then(({ CustomerPortalById: Page })=>({
            default: Page
        })));
